export enum TrackingProvider {
    NONE = 'NONE',    
    GPSTRACKING= 'GPSTRACKING',
    CARTRACK= 'CARTRACK'
}
